import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "viewzoomstyle"
    }}>{`ViewZoomStyle`}</h1>
    <p>{`View zoom style options.`}</p>
    <h2 {...{
      "id": "class"
    }}>{`Class`}</h2>
    <blockquote>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`FULL_SCREEN`}</strong>{` = 1987733107`}</p>
      <p parentName="blockquote">{`Fills the screen with the page; hides the toolbar, command bar, menu bar, and window controls.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`ZOOM_IN`}</strong>{` = 2053990766`}</p>
      <p parentName="blockquote">{`Magnifies the view to the next preset percentage.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`ZOOM_OUT`}</strong>{` = 2054124916`}</p>
      <p parentName="blockquote">{`Reduces the view to the previous preset percentage.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`FIT_PAGE`}</strong>{` = 2053534832`}</p>
      <p parentName="blockquote">{`Fits the entire page in the window.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`ACTUAL_SIZE`}</strong>{` = 2053206906`}</p>
      <p parentName="blockquote">{`Displays the page at 100% magnification.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`FIT_WIDTH`}</strong>{` = 1212437335`}</p>
      <p parentName="blockquote">{`Fits the page to the width of the window; may obscure the lower portion of the page.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`FIT_VISIBLE`}</strong>{` = 1212437334`}</p>
      <p parentName="blockquote">{`Fits the the text area of the page to the window width; obscures page margins and may obscure the lower portion of the page.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`SINGLE_PAGE`}</strong>{` = 1987736432`}</p>
      <p parentName="blockquote">{`Displays one page in the document pane at a time.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`ONE_COLUMN`}</strong>{` = 1987735395`}</p>
      <p parentName="blockquote">{`Arranges the pages in a continuous vertical column that is one page wide.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`TWO_COLUMN`}</strong>{` = 1987736675`}</p>
      <p parentName="blockquote">{`Arranges the pages side by side in a continuous vertical column that is two pages wide.`}</p>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      